class CtrStats extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.animationFrames = [];
    this.hasAnimated = false;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.teardown();
  }

  init() {
    const values = this.querySelectorAll('[ref="value"]');
    if (!values.length || this.hasAnimated) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.setFinalValues(values);
      this.hasAnimated = true;
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || this.hasAnimated) return;

          this.hasAnimated = true;
          this.observer.unobserve(this);
          this.animateValues(values);
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.25
      }
    );

    this.observer.observe(this);
  }

  setFinalValues(values) {
    values.forEach((element) => {
      const target = parseInt(element.dataset.value, 10) || 0;
      element.textContent = String(target);
    });
    this.classList.add('is-animated');
  }

  animateValues(values) {
    const duration = parseInt(this.dataset.duration, 10) || 1500;
    const stagger = 80;

    values.forEach((element, index) => {
      const target = parseInt(element.dataset.value, 10) || 0;
      const delay = index * stagger;
      const startTime = performance.now() + delay;

      const step = (now) => {
        const elapsed = now - startTime;

        if (elapsed < 0) {
          const frameId = requestAnimationFrame(step);
          this.animationFrames.push(frameId);
          return;
        }

        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.round(target * eased);

        element.textContent = String(current);

        if (progress < 1) {
          const frameId = requestAnimationFrame(step);
          this.animationFrames.push(frameId);
        } else {
          element.textContent = String(target);
        }
      };

      const frameId = requestAnimationFrame(step);
      this.animationFrames.push(frameId);
    });

    this.classList.add('is-animated');
  }

  teardown() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.animationFrames.forEach((frameId) => cancelAnimationFrame(frameId));
    this.animationFrames = [];
  }
}

customElements.get('ctr-stats') || customElements.define('ctr-stats', CtrStats);
